import { IDefineCommand } from 'core-ts-types';
import { AccountModel } from '../models/account_model';
import { LoginConfigModel } from '../models/login_config_model';
angular
  .module('data-ng-authentication')
  .factory(
    'synchronizeDeprecatedModelsCommand',
    (defineCommand: IDefineCommand, loginConfigModel: LoginConfigModel, accountModel: AccountModel) =>
      defineCommand('synchronizeDeprecatedModelsCommand', (deferred: any) => {
        accountModel.synchronize();
        loginConfigModel.synchronize();
        deferred.resolve();
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/commands/synchronize_deprecated_models_command.ts